<div class="fill-balance__content">
  <form [formGroup]="form">
    <div class="modal-header align-items-center p-3 p-sm-4">
      <h5 *ngIf="getModalStep === 1" class="modal-title f-color-dark f-size-14">
        გადახდა
      </h5>
      <h5 *ngIf="getModalStep !== 1" class="modal-title">
        <button
          class="btn btn-link pl-0 f-color-dark f-size-14 fill-balance__content__btn-left-arrow"
          (click)="openFirstStep()"
        >
          უკან
        </button>
      </h5>
      <button type="button" class="close" (click)="closeModal()">
        <img src="/assets/images/close.svg" alt="X" />
      </button>
    </div>
    <div *ngIf="getModalFirstStep" class="p-3 p-sm-4">
      <h3 class="fill-balance__content__title f-size-24 fw-bold mb-4">
        აირჩიე გადახდის მეთოდი
      </h3>
      <div>
        <div
          class="p-4 grid-container border rounded mb-3"
          (click)="openCustomStep(2)"
        >
          <div class="circle-45 border grid-container--card">
            <img src="/assets/images/credit-card-blue.svg" alt="card" />
          </div>
          <div class="grid-container--description">
            <h5 class="f-size-16 fw-medium mb-2">ბარათის მეშვეობით</h5>
            <p class="f-size-14 m-0 f-color-actions-text">
              გააქტიურე სერვისი ლივოს ბალანსის მეშვეობით
            </p>
          </div>
          <button class="grid-container--arrow btn btn-link p-0">
            <img
              class="fill-balance__content__right-arrow"
              src="/assets/images/arrow-down-light.svg"
              alt="arrow"
            />
          </button>
        </div>
        <div
          class="p-4 grid-container border rounded mb-3"
          (click)="openCustomStep(3)"
        >
          <div class="circle-45 border grid-container--card">
            <img src="/assets/images/credit-card-blue.svg" alt="card" />
          </div>
          <div class="grid-container--description">
            <h5 class="f-size-16 fw-medium mb-2">ინვოისის გამოყენებით</h5>
            <p class="f-size-14 m-0 f-color-actions-text">
              მიიტანე ინვოისი ბანკში ან გამოიყენე ონლაინ გადარიცხვისთვის
            </p>
          </div>
          <button class="btn btn-link p-0 grid-container--arrow">
            <img
              class="fill-balance__content__right-arrow"
              src="/assets/images/arrow-down-light.svg"
              alt="arrow"
            />
          </button>
        </div>
      </div>
    </div>
    <div [hidden]="!payWithInvoice" class="p-4">
      <h3 class="f-size-24 fw-bold mb-4">აირჩიე გადახდის მეთოდი</h3>

      <h5 class="f-size-14 f-color-actions-text mb-4">
        შეავსე დეტალები და გადმოწერე ინვოისი
      </h5>
      <div class="row mb-3">
        <app-text-input
          class="col-12 col-sm-6"
          formControlName="price"
          label="მიუთითეთ თანხა"
          placeholder="მიუთითეთ თანხა"
          type="number"
        ></app-text-input>
        <app-text-input
          *ngIf="isUserPhysical"
          class="col-12 col-sm-6"
          formControlName="personal_number"
          label="პირადი ნომერი"
          placeholder="მიუთითეთ პირადი ნომერი"
          type="number"
        ></app-text-input>
        <app-text-input
          *ngIf="isUserLegal"
          class="col-12 col-sm-6"
          formControlName="id_number"
          label="საიდენთიფიკაციო კოდი"
          placeholder="საიდენთიფიკაციო კოდი"
          type="number"
        ></app-text-input>
        <app-text-input
          *ngIf="isUserPhysical"
          class="col-12"
          formControlName="full_name"
          label="სახელი და გვარი"
          placeholder="მიუთითეთ სრული სახელი"
        ></app-text-input>
        <app-text-input
          *ngIf="isUserLegal"
          class="col-12"
          formControlName="legal_title"
          label="კომპანიის დასახელება"
          placeholder="მიუთითეთ კომპანიის დასახელება"
        ></app-text-input>
      </div>

      <div>
        <button
          [disabled]="!getFillPrice"
          class="col-lg-5 col mr-3 px-2 py-3 mb-lg-0 mb-3 fw-medium btn btn-primary bg-vibrant-blue f-size-14"
          (click)="print()"
        >
          ინვოისის გადმოწერა
        </button>
        <!-- <button class="col-lg-3 col px-2 py-3 fw-medium btn btn-light f-size-14">შეტანა</button> -->
      </div>
    </div>

    <div [hidden]="!payWithCard" class="p-4">
      <h3 class="f-size-24 fw-bold mb-4">ბალანსის შევსება</h3>

      <h5 class="f-size-14 f-color-actions-text mb-4">
        მიუთითეთ თანხის რაოდენობა, ბალანსის შესავსებად. <br />თითო ტრანზაქცია
        მაქსიმუმ 20 000 ლარი.
      </h5>

      <div class="row mb-4">
        <app-text-input
          class="col-12 col-sm-8"
          formControlName="price"
          label="მიუთითეთ სასურველი თანხა"
          placeholder="მიუთითეთ თანხა"
          type="number"
        ></app-text-input>

        <!-- must be selector but first need card's list -->
        <!-- <app-text-input class="col-8" formControlName="card" label="აირჩიეთ გადახდის მეთოდი" placeholder="აირჩიე ბარათი" type="number"></app-text-input>
        <div class="col-12 mt-2 d-flex">
          <app-checkbox [control]="form.get('save_card')" [elementValue]="1"></app-checkbox>
          <p class="mb-0 ml-3">დაიმახსოვრე ბარათი გადახდისას</p>
        </div> -->
      </div>
      <button
        [disabled]="getFillPrice > 20000"
        type="button"
        class="btn btn-primary p-3 fw-medium f-size-14 bg-vibrant-blue"
        (click)="onBalanceFill()"
      >
        ბალანსის შევსება
      </button>
    </div>
  </form>
</div>
<div class="fill-balance__bg" (click)="closeModal()"></div>

<!-- Print Invoice -->
<div class="print" id="print-section" [hidden]="true">
  <img src="../assets/images/logo.svg" alt="" />
  <div class="print-content align-items-center">
    <div class="print-top">
      <p><b>დასახელება :</b> {{ getFullName }}</p>
      <p>
        <b>{{ getUserInformation.id_number ? "ს/კ" : "პ/ნ" }} :</b>
        {{
          getUserInformation.id_number
            ? getUserInformation.id_number
            : getUserInformation.personal_number
        }}
      </p>
      <p><b>თარიღი :</b> {{ currentDate }}</p>
    </div>
    <div class="print-body mt-2">
      <table class="w-100">
        <thead>
          <tr>
            <th>ანგარიშზე ბალანსის შეტანა</th>
            <th>ღირებულება</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <p>
                {{
                  getUserInformation.id_number
                    ? getUserInformation.id_number
                    : getUserInformation.personal_number
                }}
              </p>
              <p>{{ getFullName }}</p>
            </td>
            <td>
              {{ getFillPrice }}
            </td>
          </tr>
          <tr>
            <td>
              ჯამი
              .............................................................................................................................
            </td>
            <td>{{ getFillPrice }} ლარი</td>
          </tr>
        </tbody>
      </table>
      <div class="info mt-3">
        <p>მიმღები: <span class="info-label">შპს თინეთი</span></p>
        <p>ს/კ: <span class="info-label">402116474</span></p>
        <p>სს “თიბისი ბანკი”</p>
        <p>მიმღები ბანკის კოდი: <span class="info-label">TBCBGE22</span></p>
        <p>
          მიმღების ანგარიშის №:
          <span class="info-label">GE28TB7165736020100006</span>
        </p>
      </div>
    </div>
  </div>
  <div class="print-footer">
    <span class="text-align-center"
      >მის: თბილისი, მ.კოსტავას ქ. #63; ტელ: (032) 2 15 86 86; ელ-ფოსტა:
      info@livo.ge</span
    >
  </div>
</div>

<!-- /Print Invoice -->
